var _circle, _circle2, _circle3, _circle4, _path, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsGroupCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 180,
    viewBox: "0 0 186 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5332,
    cy: 176.5,
    r: 3.5,
    fill: "#12D18E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.033,
    cy: 171,
    r: 1,
    fill: "#12D18E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0332,
    cy: 133,
    r: 5,
    fill: "#12D18E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 91.5,
    r: 70.5,
    fill: "#12D18E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.898 87.8499L116.498 83.8999C115.848 83.1499 115.323 81.7499 115.323 80.7499V76.4999C115.323 73.8499 113.148 71.6749 110.498 71.6749H106.248C105.273 71.6749 103.848 71.1499 103.098 70.4999L99.1482 67.0999C97.4232 65.6249 94.5982 65.6249 92.8482 67.0999L88.9232 70.5249C88.1732 71.1499 86.7482 71.6749 85.7732 71.6749H81.4482C78.7982 71.6749 76.6232 73.8499 76.6232 76.4999V80.7749C76.6232 81.7499 76.0982 83.1499 75.4732 83.8999L72.0982 87.8749C70.6482 89.5999 70.6482 92.3999 72.0982 94.1249L75.4732 98.0999C76.0982 98.8499 76.6232 100.25 76.6232 101.225V105.5C76.6232 108.15 78.7982 110.325 81.4482 110.325H85.7732C86.7482 110.325 88.1732 110.85 88.9232 111.5L92.8732 114.9C94.5982 116.375 97.4232 116.375 99.1732 114.9L103.123 111.5C103.873 110.85 105.273 110.325 106.273 110.325H110.523C113.173 110.325 115.348 108.15 115.348 105.5V101.25C115.348 100.275 115.873 98.8499 116.523 98.0999L119.923 94.1499C121.373 92.4249 121.373 89.5749 119.898 87.8499ZM106.398 86.2749L94.3232 98.3499C93.9732 98.6999 93.4982 98.8999 92.9982 98.8999C92.4982 98.8999 92.0232 98.6999 91.6732 98.3499L85.6232 92.2999C84.8982 91.5749 84.8982 90.3749 85.6232 89.6499C86.3482 88.9249 87.5482 88.9249 88.2732 89.6499L92.9982 94.3749L103.748 83.6249C104.473 82.8999 105.673 82.8999 106.398 83.6249C107.123 84.3499 107.123 85.5499 106.398 86.2749Z",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.533,
    cy: 160.5,
    r: 2.5,
    fill: "#12D18E"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.533,
    cy: 110.5,
    r: 2.5,
    fill: "#12D18E"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.0332,
    cy: 75,
    r: 1,
    fill: "#12D18E"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.466,
    cy: 27.5,
    r: 7.5,
    fill: "#12D18E"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.533,
    cy: 4.5,
    r: 2.5,
    fill: "#12D18E"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0332,
    cy: 10,
    r: 10,
    fill: "#12D18E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsGroupCheck);
export default __webpack_public_path__ + "static/media/dots-group-check.13eb2db8f0dca65e1a2e97e16b48848d.svg";
export { ForwardRef as ReactComponent };